import { Component, Input, ViewEncapsulation } from '@angular/core';
import { BasicService } from '../../services/basic.service';

/**
 * Component dedicated to display video or audio in a ionic modal, via basicService.
 * Add the class 'app-media-modal'so that the modal fit the content.
 *
 * @example
 *  this.basicService.modal(
 *    MediaModalComponent, { src: url, type: 'video' }, 'app-media-modal'
 *  );
 */
@Component({
  selector: 'app-media-modal',
  templateUrl: './media-modal.component.html',
  styleUrls: ['./media-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MediaModalComponent {
  @Input() src: string;
  @Input() type: 'video' | 'audio';

  constructor(private basicService: BasicService) {}

  dismissModal() {
    this.basicService.dismissModal();
  }
}
